export function handleVideoHeros() {
    let $elements = $('.js-hero-video');
    if ($elements.length > 0) {
        $elements.each(function () {
            handleVideoHero($(this));
        });
    }

    $(window).on('resize', function () {
        $elements.each(function () {
            handleVideoHero($(this));
        });
    });
}

function handleVideoHero($element) {
    let src;

    let aspectRatio = $(window).outerWidth() / $(window).outerHeight();


    if($(window).outerWidth() >= 1200 || aspectRatio >= 1){
        src = '/wp-content/uploads/2024/12/landscape.mp4'
    } else{
        src = '/wp-content/uploads/2024/12/portrait.mp4'
    }

    let video = $element[0];
    video.src = src;
    video.load();
}
